import React from 'react';
import { SparklesIcon } from 'lucide-react';
interface NewBadgeProps {
  label?: string;
}

/** Marks a proposed rebuild feature that does not exist in Salesforce main today. */
export function NewBadge({
  label = 'NEW · not in main today'
}: NewBadgeProps) {
  return <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-sm border border-[#B0CDF5] bg-sf-blue-light px-1.5 text-[11px] font-semibold leading-[18px] text-sf-blue-dark" data-id="element-865" data-mp="11gls1jjibr89">
      <SparklesIcon className="h-3 w-3" aria-hidden="true" data-id="element-866" data-mp="1u5aupn07o4m4" />
      {label}
    </span>;
}